export default "/images/simple-pay.png?9c03bd47a5505225250c6fb8f9f140e4";